import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import Mandatory from '../../../components/Common/Mandatory';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import API_MASTER_DATA from '../../../api/apiMasterData';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_SHIFT_INSERT } from '../../../constants/menuPermissionConstant';

class ShiftAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shiftName: '',
            shiftDescription: '',
            shiftWorkStart: '',
            shiftWorkEnd: '',
            shiftBreakStart: '',
            shiftBreakEnd: '',
            showWarningShiftName: '',
            showWarningShiftDescription: '',
            showWarningShiftWorkStart: '',
            showWarningShiftWorkEnd: '',
            showWarningShiftBreakStart: '',
            showWarningShiftBreakEnd: '',
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    postDataAddShift = () => {
        let data = {
            shift_name: this.state.shiftName,
            shift_description: this.state.shiftDescription,
            work_start: this.state.shiftWorkStart,
            work_end: this.state.shiftWorkEnd,
            break_start: this.state.shiftBreakStart,
            break_end: this.state.shiftBreakEnd
        }

        API_MASTER_DATA.postDataAddShift(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showConfirmAlert: false,
                        showSuccessAlert: true
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleRedirectListShift = () => {
        this.props.history.goBack();
    }

    handleAddNewShift = () => {
        // Jika ada field yang kosong
        if (!this.state.shiftName) this.setState({ showWarningShiftName: true });
        if (!this.state.shiftDescription) this.setState({ showWarningShiftDescription: true });
        if (!this.state.shiftWorkStart) this.setState({ showWarningShiftWorkStart: true });
        if (!this.state.shiftWorkEnd) this.setState({ showWarningShiftWorkEnd: true });
        if (!this.state.shiftBreakStart) this.setState({ showWarningShiftBreakStart: true });
        if (!this.state.shiftBreakEnd) this.setState({ showWarningShiftBreakEnd: true });

        // Jika tidak ada field yang kosong
        if (this.state.shiftName && this.state.shiftDescription && this.state.shiftWorkStart && this.state.shiftWorkEnd && this.state.shiftBreakStart && this.state.shiftBreakEnd) {
            this.setState({ showConfirmAlert: true });
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_SHIFT_INSERT]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Shift"
                        title="Tambah Shift"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-ticket bg-white border border-gray-300 rounded-lg px-6 py-10 overflow-auto">
                            <div className="w-1/2 space-y-6">
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Nama Shift <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslshiftname"
                                        className="form-control"
                                        placeholder="Tulis Nama Shift"
                                        name="shiftName"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftName: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftName && <MandatoryAlert text="Nama Shift tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslshiftdescription"
                                        className="form-control"
                                        placeholder="Tulis Deskripsi"
                                        name="shiftDescription"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftDescription: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftDescription && <MandatoryAlert text="Deskripsi tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Jam Mulai <Mandatory /></p>
                                    <input
                                        type="time"
                                        id="tslworkstart"
                                        className="form-control"
                                        placeholder="Tulis Jam Mulai"
                                        name="shiftWorkStart"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftWorkStart: false });
                                        }}
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftWorkStart && <MandatoryAlert text="Jam Mulai tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Jam Selesai <Mandatory /></p>
                                    <input
                                        type="time"
                                        id="tslworkend"
                                        className="form-control"
                                        placeholder="Tulis Jam Selesai"
                                        name="shiftWorkEnd"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftWorkEnd: false });
                                        }}
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftWorkEnd && <MandatoryAlert text="Jam Selesai tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Jam Istirahat Mulai <Mandatory /></p>
                                    <input
                                        type="time"
                                        id="tslworkstart"
                                        className="form-control"
                                        placeholder="Tulis Jam Istirahat Mulai"
                                        name="shiftBreakStart"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftBreakStart: false });
                                        }}
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftBreakStart && <MandatoryAlert text="Jam Istirahat Mulai tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Jam Istirahat Selesai <Mandatory /></p>
                                    <input
                                        type="time"
                                        id="tslworkend"
                                        className="form-control"
                                        placeholder="Tulis Jam Istirahat Selesai"
                                        name="shiftBreakEnd"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftBreakEnd: false });
                                        }}
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftBreakEnd && <MandatoryAlert text="Jam Istirahat Selesai tidak boleh kosong!" />}
                                </div>
                            </div>
                        </div>

                        {/* Action Button */}
                        <div className="flex flex-row-reverse">
                            <div className="space-x-3 pt-3">
                                <ButtonBorderNexcareDefault onClick={() => this.handleRedirectListShift()}>
                                    Batal
                                </ButtonBorderNexcareDefault>
                                <ButtonNexcareDefault onClick={() => this.handleAddNewShift()}>
                                    Tambah
                                </ButtonNexcareDefault>
                            </div>
                        </div>
                    </div>

                    <Alert show={this.state.showConfirmAlert} button title="Simpan Shift" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.postDataAddShift()} />
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={() => this.handleRedirectListShift()} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftAdd);